import React from 'react';

const PageLoader = () => {
    return (
        <div className="min-h-screen flex flex-col items-center justify-center bg-slate-50 dark:bg-slate-950">
            <div className="relative w-24 h-24 sm:w-28 sm:h-28 flex items-center justify-center">
                {/* Rotating ring around icon */}
                <div className="absolute inset-0 flex items-center justify-center">
                    <div className="animate-spin rounded-full w-full h-full border-4 border-indigo-200 dark:border-indigo-900 border-t-indigo-600 dark:border-t-indigo-400"></div>
                </div>
                {/* Animated restaurant icon */}
                <div className="relative z-10">
                    <i className="ri-restaurant-2-line text-6xl sm:text-7xl text-indigo-600 dark:text-indigo-400 animate-pulse" />
                </div>
            </div>
        </div>
    );
};

export default PageLoader;
